export default __webpack_public_path__ + "static/media/Artboard 12.16e28bdd.png";